module.exports = __webpack_public_path__ + "2342a07a7a82fe9714a3a1a3ab14d27e.jpg";